export default {

    /*html*/
    template: `
        <div class="py-3 flex items-center flex-col">
            <h2 class="text-5xl text-secondary font-bold text-center pt-[25px]">Hola</h2>
            <p class="text-center text-md text-third !mt-5 max-w-[500px] dynamic-color">
            Estoy aquí para ayudarte a facilitar tu trabajo y ahorrar tiempo. Puedo asistirte con tus consultas legales, redacción de borradores básicos de documentos, corrección de gramática, análisis de temas jurídicos, creación de tablas, revisión de documentos y mucho más.
            </p>

            <p class="text-center text-md text-third !mt-5 max-w-[500px] dynamic-color">
                También puedes <a href="#" @click="$emit('startAudioCall')" class="text-theme-color hover:underline cursor-pointer">iniciar una llamada conmigo</a> para una experiencia más conversacional.
            </p>
        </div>`
}